/* EL MOTOR DE LOS PANELES · 27-ago-2026
 *
 * 🔴 POR QUÉ EXISTE. Los tres paneles del sitio —bolsa, guardados y buscador—
 * abrían con una `animation` de CSS y cerraban con `panel.hidden = true`. Y una
 * `animation` solo corre al ENTRAR: al cerrar, `hidden` pone `display:none` y el
 * panel desaparece en el mismo cuadro. Medido el 27-ago en el borrador con un
 * muestreo cuadro por cuadro: abriendo, el cajón viaja 1280 → 846 px en diez
 * cuadros; cerrando, `hidden` ya está puesto y el ancho es 0 en el cuadro CERO.
 * Entra con cuidado y se va de un tirón. Eso es lo que se siente "raro".
 *
 * 🔴 LA REGLA QUE SE PORTÓ, medida en vivo el mismo día en tres casas:
 *   · Tôtemé  → `transition: opacity .3s ease-out, visibility .3s` en el cajón,
 *     y keyframes `menu-slide-down` Y `menu-slide-up`. La salida está escrita.
 *   · Aesop   → `fadeIn`/`fadeOut`, `slideUpIn`/`slideUpOut`. Pares, siempre.
 *   · SSENSE  → `enter`/`exit`, `accordionDown`/`accordionUp`. Pares otra vez.
 * Tres sitios, el mismo hallazgo: LA SALIDA SE ESCRIBE, NO SE SUPONE.
 *
 * 🔴 POR QUÉ NO SE RESOLVIÓ SOLO CON CSS. `@starting-style` +
 * `transition-behavior: allow-discrete` haría esto sin una línea de JS, pero
 * `allow-discrete` pide Safari 18 y el tráfico de esta tienda es casi todo
 * iPhone: quien vaya en iOS 17 se quedaría con el cierre de golpe de hoy. El
 * atributo lo entiende cualquier navegador.
 *
 * 🔴 Y POR QUÉ HACEN FALTA DOS CUADROS AL ABRIR. Quitar `hidden` y poner el
 * atributo de abierto en el mismo cuadro deja al navegador sin un estado
 * inicial que interpolar: aplica el valor final de una y no hay transición.
 * Un `requestAnimationFrame` anidado le da el cuadro donde el panel ya existe
 * con su posición de reposo.
 */
(function () {
  'use strict';

  function quieto() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* La hoja es lo que se desliza; el contenedor es el telón. Si el panel no
     marca cuál es, se toma su primer hijo — es lo que son los tres de hoy. */
  function hojaDe(panel) {
    return panel.querySelector('[data-panel-hoja]') || panel.firstElementChild;
  }

  /* La página que retrocede. Se marca en la RAÍZ y no en el lienzo porque el
     CSS necesita cambiar también el fondo del `<body>`, que es su hermano. */
  var raiz = document.documentElement;
  var abiertos = 0;

  /* 🔴 SE LLAMA `retrocede` Y NO `hoja` POR UN MOTIVO CONCRETO: dentro de
     `cierra()` ya existe `var hoja = hojaDe(panel)` —el elemento del panel—, y
     un `var` con el mismo nombre TAPA a esta función en todo ese ámbito.
     Llamar `hoja(false)` ahí dentro intentaba invocar un elemento del DOM.
     Y no se vio como un fallo de ámbito sino como `hoja2 is not a function`,
     porque el minificador de Shopify renombra el de fuera al desambiguar: el
     mensaje señala un nombre que no existe en el código escrito. */
  function retrocede(entra) {
    if (quieto()) return;
    abiertos = Math.max(0, abiertos + (entra ? 1 : -1));
    /* Se cuenta en vez de poner/quitar a secas: con el buscador abierto encima
       del cajón, cerrar uno devolvería la página a su sitio con el otro todavía
       arriba. Solo se endereza cuando no queda ninguno. */
    if (abiertos > 0) raiz.setAttribute('data-hoja', '');
    else raiz.removeAttribute('data-hoja');
  }

  var Panel = {
    abre: function (panel) {
      panel.hidden = false;
      retrocede(true);
      if (quieto()) { panel.setAttribute('data-abierto', ''); return; }
      panel.removeAttribute('data-cerrando');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { panel.setAttribute('data-abierto', ''); });
      });
    },

    /* `luego` corre cuando el panel ya se fue de pantalla: ahí es donde va
       destrabar el fondo. Destrabar al principio hace que la página de atrás
       recupere su scroll mientras el telón todavía se está apagando, y eso se
       ve como un brinco detrás del panel. */
    cierra: function (panel, luego) {
      function fin() {
        panel.removeAttribute('data-cerrando');
        panel.hidden = true;
        if (luego) luego();
      }

      /* La página se endereza AL EMPEZAR el cierre, no al terminar: el lienzo
         tarda 0.5s y el panel 0.24s, así que arrancando juntos la página acaba
         de asentarse justo después de que la hoja se fue. Si esperara al final,
         habría un cuarto de segundo con la página encogida y nada encima. */
      retrocede(false);
      panel.removeAttribute('data-abierto');
      if (quieto()) { fin(); return; }

      var hoja = hojaDe(panel);
      if (!hoja) { fin(); return; }

      panel.setAttribute('data-cerrando', '');

      /* 🔴 RED DE SEGURIDAD OBLIGATORIA. Si el panel está en una pestaña de
         fondo, o alguien le quita la transición, o el navegador se salta el
         evento, `transitionend` no llega NUNCA y el panel se queda abierto
         para siempre — un fallo mucho peor que el que se está arreglando. El
         reloj cierra igual pasado el tiempo de la salida con holgura. */
      var reloj = setTimeout(cerrarYa, 600);

      function alFin(ev) {
        if (ev.target !== hoja) return;   /* los hijos también burbujean */
        cerrarYa();
      }
      function cerrarYa() {
        clearTimeout(reloj);
        hoja.removeEventListener('transitionend', alFin);
        fin();
      }

      hoja.addEventListener('transitionend', alFin);
    }
  };

  /* ── ARRASTRAR PARA CERRAR ────────────────────────────────────────────────
   * 🔴 ES LO QUE MÁS DICE "APP". Un cajón que solo se cierra con una equis es
   * una ventana; uno que se va con el pulgar es una hoja. En iPhone el gesto de
   * apartar algo con el dedo está tan aprendido que la gente lo intenta sin
   * pensar — y hasta hoy aquí no pasaba nada.
   *
   * 🔴 `touch-action: pan-y` ES LO QUE LO HACE POSIBLE (va en el CSS del panel).
   * Le dice al navegador: el desplazamiento VERTICAL sigue siendo tuyo —la
   * lista de prendas se sigue recorriendo nativa, a 60fps, sin que yo la
   * toque—, el HORIZONTAL es mío. Sin eso habría que cancelar el scroll a mano
   * y la lista se sentiría pegajosa.
   *
   * 🔴 SE DECIDE POR VELOCIDAD, NO SOLO POR DISTANCIA. Un empujón corto y
   * rápido tiene que cerrar; un arrastre largo y lento que se detiene a medias
   * tiene que volver. Juzgar solo por distancia hace que el gesto rápido —el
   * natural— se sienta roto. Umbrales: 45% del ancho, o 0.45 px/ms de salida.
   *
   * ⚠️ Y AL SOLTAR SIN CERRAR, EL PANEL VUELVE CON RESORTE. Ahí es donde el
   * sobrepaso del 2% se nota de verdad: el panel se pasa un pelo de su sitio y
   * se acomoda. Es la diferencia entre "volvió" y "está vivo".
   */
  function arrastre(panel, alCerrar) {
    var hojaEl = hojaDe(panel);
    if (!hojaEl) return;

    var activo = false, decidido = false, x0 = 0, y0 = 0, dx = 0;
    var t0 = 0, xPrevio = 0, tPrevio = 0, velocidad = 0, ancho = 1;

    hojaEl.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (quieto()) return;
      /* Ni sobre los botones de cantidad ni sobre un enlace: ahí el dedo va a
         tocar, no a arrastrar, y robarle el toque se siente como un fallo. */
      if (e.target.closest('button, a, input, select')) return;
      activo = true; decidido = false;
      x0 = xPrevio = e.clientX; y0 = e.clientY;
      t0 = tPrevio = e.timeStamp; dx = 0; velocidad = 0;
      ancho = hojaEl.getBoundingClientRect().width || 1;
    });

    hojaEl.addEventListener('pointermove', function (e) {
      if (!activo) return;
      var mx = e.clientX - x0, my = e.clientY - y0;

      /* Hasta que el gesto no se declara, no se toca nada: si el dedo va
         claramente en vertical, esto es un scroll y hay que soltarlo. */
      if (!decidido) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        if (Math.abs(my) > Math.abs(mx)) { activo = false; return; }
        decidido = true;
        hojaEl.setAttribute('data-arrastrando', '');
        try { hojaEl.setPointerCapture(e.pointerId); } catch (err) {}
      }

      var dt = e.timeStamp - tPrevio;
      if (dt > 0) velocidad = (e.clientX - xPrevio) / dt;
      xPrevio = e.clientX; tPrevio = e.timeStamp;

      /* Hacia dentro (izquierda) hay goma: el panel ya está en su tope y tirar
         más no puede despegarlo del borde. Sin resistencia se sentiría suelto
         y roto; con ella, sólido. */
      dx = mx > 0 ? mx : mx * 0.22;
      hojaEl.style.transition = 'none';
      hojaEl.style.translate = dx + 'px 0';
      /* El telón se va aclarando con el arrastre: informa de cuánto falta para
         que el gesto surta efecto, antes de soltar. */
      panel.style.setProperty('--avance', String(Math.max(0, 1 - dx / ancho)));
    });

    function suelta(e) {
      if (!activo) return;
      activo = false;
      hojaEl.style.transition = '';
      panel.style.removeProperty('--avance');
      if (!decidido) return;
      decidido = false;
      hojaEl.removeAttribute('data-arrastrando');
      try { hojaEl.releasePointerCapture(e.pointerId); } catch (err) {}

      var seVa = dx > ancho * 0.45 || velocidad > 0.45;
      if (seVa) {
        hojaEl.style.translate = '';
        alCerrar();
      } else {
        /* Vuelve a su sitio con resorte. El `translate` se limpia al terminar
           para no dejar un estilo en línea que gane sobre el CSS del cierre. */
        hojaEl.style.transition = 'translate 0.42s var(--ease-resorte)';
        hojaEl.style.translate = '0px 0';
        setTimeout(function () {
          hojaEl.style.transition = '';
          hojaEl.style.translate = '';
        }, 460);
      }
      dx = 0; velocidad = 0;
    }

    hojaEl.addEventListener('pointerup', suelta);
    hojaEl.addEventListener('pointercancel', suelta);
  }

  Panel.arrastrable = arrastre;
  window.AvoraPanel = Panel;
})();
